var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: {
        title: "Domains and Font Awesome Kits",
        "component-class": "kits-and-domains",
        "is-showing": _vm.isShowing,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _c("p", { staticClass: "margin-bottom-2xl" }, [
        _vm._v(
          "\n    Just as we think it's best to have a dedicated kit per project or site, we recommend specifying particular domains for use with each of your Font Awesome\n    kits.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Why Should I Define Domains?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Specifying a domain can help you control where and how you're using Font Awesome Kits - which helps avoid unexpected extreme usage as well as violation of\n    the Font Awesome Pro license.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("How do I Specify Domains?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    You can add as many domains as you'd like. You can specify complete domains or use wildcards (*) to cover subdomains or different domain endings (.com,\n    .org, etc.). Here are some examples…\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { overflow: "scroll" } }, [
        _c("table", { staticClass: "roomy" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("Domain Examples")]),
              _vm._v(" "),
              _c("th", [_vm._v("Notes")]),
            ]),
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", { attrs: { scope: "row" } }, [_vm._v("www.empire.gov")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "Will cover Font Awesome Kits usage for the https://www.empire.gov, but not https://empire.gov. If you need both, make sure to add each one."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { scope: "row" } }, [_vm._v("empire.gov")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "Will cover Font Awesome Kits usage for the https://empire.gov, but not https://www.empire.gov. If you need both, make sure to add each one."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { scope: "row" } }, [_vm._v("*.rebels.org")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "Will cover all subdomains under the rebels.org domain."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { attrs: { scope: "row" } }, [
                _vm._v("council.jedi.org, padawans.jedi.org, exiled.jedi.org"),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "Will render icons on each of these specific 3 Jedi domains. Just don't tweet them out to Lord Vader."
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "th",
                {
                  staticStyle: { color: "var(--fa-dk-yellow)" },
                  attrs: { scope: "row" },
                },
                [_vm._v("\n            the-force.*\n          ")]
              ),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  {
                    staticClass: "display-flex flex-row flex-content-between",
                    staticStyle: { gap: "var(--spacing-2xl)" },
                  },
                  [
                    _c(
                      "span",
                      { staticStyle: { color: "var(--fa-dk-yellow)" } },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v7.solid.faExclamationTriangle,
                            size: "xl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      '\n\n              Will render icons on any domain ending so long as it contains "the-force". This may have unintended consequences since one probably does not own\n              all of the domains + domain ending combinations.\n            '
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c(
                "th",
                {
                  staticStyle: { color: "var(--fa-dk-red)" },
                  attrs: { scope: "row" },
                },
                [
                  _vm._v(
                    "\n            *.wordpress.com, *.squarespace.com\n          "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  {
                    staticClass: "display-flex flex-row flex-content-between",
                    staticStyle: { gap: "var(--spacing-2xl)" },
                  },
                  [
                    _c(
                      "span",
                      { staticStyle: { color: "var(--fa-dk-red)" } },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: _vm.$v7.solid.faExclamationTriangle,
                            size: "xl",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(
                      "\n\n              Will make your kit, and thus Font Awesome Pro, available to any sites that are published under blogging or site creator tools like this. This is\n              a violation of the Font Awesome Pro license.\n            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }